<template>
	<div>
		<main id="main">
			<section class="breadcrumbs">
			  <div class="container">
			    <ol>
			      <li><router-link to="/"><a href="">首页</a></router-link></li>
				  <li>产品中心</li>
				</ol>
				<h2>产品中心</h2>
			  </div>
			</section>
			
			<section id="blog" class="blog">
			  <div class="container" data-aos="fade-up">
				<div class="row">
					
					<!-- 左侧 -->
					<div class="col-lg-4">
					  <div class="sidebar">
						
						<h3 class="sidebar-title">产品类型</h3>
						<div class="sidebar-item categories">
						  <ul>
							<li v-for="item in productType"><router-link :to="'/productCenter?id='+item.ptId">{{item.ptName}} </router-link></li>
						  </ul>
						</div>
					  </div>
					</div>

				<!-- 右侧 -->	
				  <div class="col-lg-8 entries">
					<div class="row">
					  <div class="col-lg-4 cur" v-for="item in product" @click="toProductDetail(item)">
					    <div class="box" data-aos="fade-up" data-aos-delay="200">
						   <el-image
						   class="img-fluid"
						   	:src="$global.baseURL + item.productPicture" 
						   	alt="图片加载失败"
						   	lazy>
						   </el-image>
					      <h4 style="text-align: center;">{{item.productName}}</h4>
					    </div>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
			</section>

		</main>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState } from 'vuex'
	export default{
		data() {
			return {
				product: [],
				productAll: []
			}
		},
		computed:{
			...mapState({
				productType: state => state.productType,
			})
		},
		watch:{
			"$route.query.id":{
				immediate:true, // 一开始的数据也要当做一种变化
				async handler(val,old){
					await this.getProduct(val);
					this.product = this.productAll.filter(item=>item.ptId == val);
				}
			},
		},
		methods:{
			// 跳转到产品详情页
			toProductDetail(item){
				const pro = encodeURIComponent(JSON.stringify(item));
				this.$router.push({
					path: "/productDetail",
					query: {pro}
				});
			},
			async getProduct(){
				try{
					const resp = await axios.get('/api/system/product/listAll');
					this.productAll = [];
					this.productAll = JSON.parse(JSON.stringify(resp.data.rows));
				}catch(e){
					console.log(e);
				}
			}
		}
	}
</script>
<style scoped>
	.img-fluid{
		width: 100%;
		height: 220px;
	}
	.img-fluid img{
		object-fit: cover;
	}
	.el-image_inner{
		object-fit: cover;
	}
</style>